import React from 'react';

const RecruitmentOfEmployees = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    role="img"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.625 16.125C11.5245 16.125 13.875 13.7745 13.875 10.875C13.875 7.97551 11.5245 5.625 8.625 5.625C5.72551 5.625 3.375 7.97551 3.375 10.875C3.375 13.7745 5.72551 16.125 8.625 16.125Z"
      fill="#FB6121"
    />
    <path
      d="M21.375 30.375C13.875 26.625 13.875 19.875 7.875 19.875C6.2945 19.9094 4.78829 20.5526 3.67045 21.6704C2.5526 22.7883 1.90941 24.2945 1.875 25.875V43.125H13.875V31.125"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M40.125 16.125C43.0245 16.125 45.375 13.7745 45.375 10.875C45.375 7.97551 43.0245 5.625 40.125 5.625C37.2255 5.625 34.875 7.97551 34.875 10.875C34.875 13.7745 37.2255 16.125 40.125 16.125Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M27.375 30.375C34.875 26.625 34.875 19.875 40.875 19.875C42.4555 19.9094 43.9617 20.5526 45.0796 21.6704C46.1974 22.7883 46.8406 24.2945 46.875 25.875V43.125H34.875V31.125"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </svg>
);

export default RecruitmentOfEmployees;
